/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CompanyUuidReportIdRouteImport } from './routes/$companyUuid.$reportId'

const CompanyUuidReportIdRoute = CompanyUuidReportIdRouteImport.update({
  id: '/$companyUuid/$reportId',
  path: '/$companyUuid/$reportId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/$companyUuid/$reportId': typeof CompanyUuidReportIdRoute
}
export interface FileRoutesByTo {
  '/$companyUuid/$reportId': typeof CompanyUuidReportIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$companyUuid/$reportId': typeof CompanyUuidReportIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/$companyUuid/$reportId'
  fileRoutesByTo: FileRoutesByTo
  to: '/$companyUuid/$reportId'
  id: '__root__' | '/$companyUuid/$reportId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  CompanyUuidReportIdRoute: typeof CompanyUuidReportIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$companyUuid/$reportId': {
      id: '/$companyUuid/$reportId'
      path: '/$companyUuid/$reportId'
      fullPath: '/$companyUuid/$reportId'
      preLoaderRoute: typeof CompanyUuidReportIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  CompanyUuidReportIdRoute: CompanyUuidReportIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
